import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import * as Types from 'js/components/main/BonusHistory/hooks/useTableData/types';
import { FormattedRowsType } from './types';
import { makeConfig } from '@theme/js/utils/makeConfig';
import { getFreeSpinsFormattedData } from './getFreeSpinsFormattedData';
import { getGoldenChipsFormattedData } from './getGoldenChipsFormattedData';
import { BONUS_AMOUNT_TYPES } from '../constants';
import { getPrewagerFormattedData } from './getPrewagerFormattedData';
import { getDefaultFormattedData } from './getDefaultFormattedData';

export const getFormattedData = ({
    translate,
    isDesktop = false,
    additionalRows = [],
    formatCurrency
}: FormattedRowsType): (item: IBonusToDisplay) => Types.IAccordionRow[] =>
    (item: IBonusToDisplay) => {

    const dataFormatter = makeConfig<(item: IBonusToDisplay) => Types.IAccordionRow[], string>({
        [BONUS_AMOUNT_TYPES.FREE_SPINS]: getFreeSpinsFormattedData({
            translate,
            isDesktop,
            additionalRows,
            formatCurrency
        }),
        [BONUS_AMOUNT_TYPES.FREE_SPINS2]: getFreeSpinsFormattedData({
            translate,
            isDesktop,
            additionalRows,
            formatCurrency
        }),
        [BONUS_AMOUNT_TYPES.GOLDEN_CHIPS]: getGoldenChipsFormattedData({
            translate,
            isDesktop,
            additionalRows,
            formatCurrency
        }),
        [BONUS_AMOUNT_TYPES.PREWAGER]: getPrewagerFormattedData({
            translate,
            isDesktop,
            additionalRows,
            formatCurrency
        }),
        default: getDefaultFormattedData({
            translate,
            isDesktop,
            additionalRows,
            formatCurrency
        })
    })(item.playType || '');

    return dataFormatter(item);
};
